import { useTranslation } from 'react-i18next';

import AiOnbaordingBanner from '@/modules/AiAgents/components/AiOnbaordingBanner';
import {
  ConnectEcoSystem,
  SetupGuide,
  VerifyEmailBanner,
} from '@/modules/Onboarding';
import { Typography } from '@/shared/components/atoms';
import { useAuth } from '@/shared/hooks/context/auth';
import { useStore } from '@/shared/hooks/context/createGenericContext';

const Onboarding = () => {
  const { t } = useTranslation('onboarding');
  const { user } = useAuth();
  const [isDemoFarm] = useStore((store) => store?.isDemoFarm);

  return (
    <div className='flex w-full flex-col gap-24'>
      <div className='flex flex-col gap-2 leading-none'>
        <h1 className='text-30 font-semi-bold capitalize text-text-default'>
          {t('hi', {
            name: user?.firstName,
          })}{' '}
          👋
        </h1>
        <Typography className='text-grey-600' variant='body1'>
          {t('onboarding-list-description')}
        </Typography>
      </div>
      <div className='relative flex w-full flex-col gap-16 pb-24 desktop:flex-row'>
        <div className='flex w-full flex-col gap-16 desktop:w-2/3'>
          {!user?.isEmailVerified && user?.email && !isDemoFarm ? (
            <VerifyEmailBanner />
          ) : (
            ''
          )}
          <AiOnbaordingBanner />
          <SetupGuide />
        </div>
        <ConnectEcoSystem />
      </div>
    </div>
  );
};

export { Onboarding };
